import type { ReactNode } from 'react';
import { Form } from 'react-bootstrap';
import { ArrowRepeat } from 'react-bootstrap-icons';

import './AutoRestartCard.scss';

interface Props {
  readonly enabled: boolean;
  readonly disabled?: boolean;
  readonly switchId: string;
  readonly switchAriaLabel: string;
  readonly title: string;
  readonly subtitle: string;
  readonly pillOnLabel: string;
  readonly pillOffLabel: string;
  readonly offNote: string;
  readonly onEnableChange: (checked: boolean) => void;
  readonly children?: ReactNode;
}

/** Shared header/switch shell for node-level and loop-edge restart limit cards. */
export const AutoRestartLimitsShell = ({
  enabled,
  disabled = false,
  switchId,
  switchAriaLabel,
  title,
  subtitle,
  pillOnLabel,
  pillOffLabel,
  offNote,
  onEnableChange,
  children,
}: Props) => (
  <div className={`auto-restart${enabled ? '' : ' auto-restart--off'}`}>
    <header className="auto-restart__head">
      <span className="auto-restart__icon" aria-hidden>
        <ArrowRepeat />
      </span>
      <span className="auto-restart__titles">
        <span className="auto-restart__title">{title}</span>
        <span className="auto-restart__subtitle">{subtitle}</span>
      </span>
      <span className="auto-restart__controls">
        <span className={`auto-restart__pill auto-restart__pill--${enabled ? 'fail' : 'off'}`}>
          <span className="auto-restart__dot" />
          {enabled ? pillOnLabel : pillOffLabel}
        </span>
        <Form.Check
          type="switch"
          id={switchId}
          className="auto-restart__switch"
          checked={enabled}
          disabled={disabled}
          aria-label={switchAriaLabel}
          onChange={(event) => onEnableChange(event.target.checked)}
        />
      </span>
    </header>

    {enabled && children ? <div className="auto-restart__body">{children}</div> : <div className="auto-restart__off-note">{offNote}</div>}
  </div>
);
